export default class Colors {
	public static readonly primary = '#003E64';
	public static readonly secondary = '#ddd';
	public static readonly tertiary = '#DFDFDF';
	public static readonly quaternary = '#E5E5E5';
	public static readonly quinary = '#f2f2f2';
	public static readonly senary = '#fff';
	public static readonly error = '#CE2828';
	public static readonly font = '#000';
	public static readonly success = '#28BECE';
}